/**
 * RFC-003 §6.2：获取项目可挂载的业务权限组列表。
 * 仅供高级项目授权 / 兼容入口使用；默认项目成员管理只配置项目职能。
 */
import { useQuery } from '@tanstack/react-query';
import { projectApi } from '@/services/api';

export const projectPermissionGroupKeys = {
  all: ['project-permission-groups'] as const,
  byProject: (projectId: string) =>
    [...projectPermissionGroupKeys.all, 'by-project', projectId] as const,
};

/**
 * 拉取某项目可用于挂载的权限组。
 *
 * @param projectId 目标项目 ID（必须是 EPN；聚合节点也会返回，但前端应禁用入口）。
 * @param enabled 是否启用查询，默认 `true`。
 */
export function useProjectPermissionGroups(projectId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: projectPermissionGroupKeys.byProject(projectId ?? ''),
    queryFn: () => projectApi.getPermissionGroups(projectId!),
    enabled: enabled && !!projectId,
    staleTime: 5 * 60 * 1000,
  });
}
